module.exports = __webpack_public_path__ + "img/Autism.9f56677f.png";